<template>
  <div class="max-w-2xl mx-auto py-8 px-4">
    <h2 class="text-2xl font-bold mb-2">Ce qui change concrètement</h2>
    <p class="text-gray-600 mb-6">
      Voici le détail des changements entre l'ancien contrat MMA et le nouveau contrat Acheel :
    </p>

    <div class="overflow-x-auto">
      <table class="w-full text-sm border-collapse">
        <thead>
          <tr class="border-b-2 border-gray-200 bg-gray-50">
            <th class="text-left py-3 px-4"></th>
            <th class="text-left py-3 px-4 font-semibold uppercase text-xs tracking-wide text-gray-500">
              Ancien contrat (MMA)
            </th>
            <th class="text-left py-3 px-4 font-semibold uppercase text-xs tracking-wide text-gray-500">
              Nouveau contrat (Acheel)
            </th>
          </tr>
        </thead>
        <tbody>
          <tr class="border-b border-gray-100">
            <td class="py-3 px-4 font-bold">Garantie casse accidentelle</td>
            <td class="py-3 px-4">Couverte</td>
            <td class="py-3 px-4">Couverte</td>
          </tr>
          <tr class="border-b border-gray-100">
            <td class="py-3 px-4 font-bold">Garantie vol (vélo complet)</td>
            <td class="py-3 px-4">Couverte</td>
            <td class="py-3 px-4">Couverte</td>
          </tr>
          <tr class="border-b border-gray-100 bg-red-50">
            <td class="py-3 px-4">
              <span class="font-bold">&#9888; Garantie vol partiel</span>
              <br />
              <span class="text-xs text-gray-500">(accessoires, composants)</span>
            </td>
            <td class="py-3 px-4">Couverte</td>
            <td class="py-3 px-4 text-red-600 font-bold">Non couverte</td>
          </tr>
          <tr class="border-b border-gray-100 bg-yellow-50">
            <td class="py-3 px-4 font-bold">Franchise vol</td>
            <td class="py-3 px-4">5 % (min. 100 &euro;)</td>
            <td class="py-3 px-4 font-bold">15 % (min. 300 &euro;)</td>
          </tr>
          <tr class="border-b border-gray-100 bg-yellow-50">
            <td class="py-3 px-4 font-bold">Franchise casse</td>
            <td class="py-3 px-4">Selon conditions</td>
            <td class="py-3 px-4 font-bold">100 &euro; forfaitaire</td>
          </tr>
          <tr class="border-b border-gray-100 bg-yellow-50">
            <td class="py-3 px-4 font-bold">Vétusté</td>
            <td class="py-3 px-4">25 % après 25 mois puis 1 %/mois</td>
            <td class="py-3 px-4 font-bold">1 %/mois dès la date d'achat</td>
          </tr>
          <tr v-if="plan.monthly" class="border-b border-gray-100 bg-yellow-50">
            <td class="py-3 px-4 font-bold">Cotisation mensuelle</td>
            <td class="py-3 px-4">{{ oldPrice ? `${oldPrice}/mois` : "—" }}</td>
            <td class="py-3 px-4 font-bold">{{ newPrice ? `${newPrice}/mois` : "—" }}</td>
          </tr>
          <tr class="border-b border-gray-100">
            <td class="py-3 px-4 font-bold">Engagement</td>
            <td class="py-3 px-4">Sans engagement</td>
            <td class="py-3 px-4">Sans engagement</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="mt-6">
      <Alert type="info">
        Le détail complet figure dans le
        <span class="font-bold">Courrier d'information de changement de formule</span>
        et la
        <span class="font-bold">Notice d'information Acheel</span>
        , que vous pouvez ouvrir à tout moment depuis votre espace.
      </Alert>
    </div>

    <div class="mt-8 flex justify-between">
      <SecondaryButton @click="$emit('previous')">PRÉCÉDENT</SecondaryButton>
      <PrimaryButton @click="$emit('next')">J'AI COMPRIS, CONTINUER &rarr;</PrimaryButton>
    </div>
  </div>
</template>

<script>
import { Alert, PrimaryButton, SecondaryButton, formatPriceTTC } from "@estaly/ui";

export default {
  components: { Alert, PrimaryButton, SecondaryButton },

  props: {
    plan: {
      type: Object,
      required: true,
    },
  },

  emits: ["next", "previous"],

  computed: {
    oldPrice() {
      const contractUpdate = this.plan?.contractUpdates?.[0];
      return contractUpdate ? formatPriceTTC(contractUpdate.price) : "";
    },
    newPrice() {
      return formatPriceTTC(this.plan?.price);
    },
  },
};
</script>
